/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import { AppNavigatorService } from '@/AppNavigator';
import { vappContainer } from '@/application';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Lightbox from 'react-awesome-lightbox';
import 'react-awesome-lightbox/build/style.css';

export interface IImageModalProps {
  title?: string;
  showModal: boolean;
  imageSrc?: string;
  onDeny?(): void;
}
const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export const ImageModal = ({
  showModal,
  onDeny,
  imageSrc,
  title,
}: IImageModalProps) => {

  const [srrc,setsrc] = useState(imageSrc);
  let src = imageSrc;
  useEffect(()=>{
    setsrc(imageSrc)
    const fetchcl = async (src:any) => {
      console.log("ADSADSAS-->came in useeffect",src,imageSrc)
      const token = loginSrv()?.getToken();
      try {
        const response = await axios.get(src, {
          headers: {
            'Content-Type': 'application/json',
            Authentication: `${token}`,
          },
          responseType: 'arraybuffer',
        });
      
        const data = response.data;
        
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(new Blob([data]));
          reader.onload = () => {
            const res = reader.result + '';
            console.log("final_initdata", res);
            setsrc(res)
            resolve(res);
          };
          reader.onerror = error => reject(error);
        });
      } catch (error) {
        console.error('Error:', error);
        // Handle error
      }
    }
    src= fetchcl(imageSrc)},[imageSrc])
  
      
    
  

  const _onDeny = () => {
    if (onDeny) {
      onDeny();
    }
  };
  if (showModal && imageSrc && src) {
    //@ts-ignore
    return <Lightbox image={srrc} title={title} onClose={_onDeny} />;
  }
  return null;
};

ImageModal.defaultProps = {
  showModal: false,
};
